"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M3.997 8.208h1.84C5.92 5.795 6.642 4.34 7.673 3.5c1.08-.88 2.392-1 3.32-1 .924 0 2.238.112 3.318.99 1.032.838 1.755 2.294 1.838 4.718h1.84c.864 0 1.53.762 1.413 1.62l-.047.346a.476.476 0 1 1-.943-.128l.047-.347a.476.476 0 0 0-.47-.54H6.76c-.002.202.003.407.009.631.005.22.01.458.01.729a.476.476 0 1 1-.95 0q-.002-.324-.01-.64a23 23 0 0 1-.01-.72H3.998a.476.476 0 0 0-.47.54l1.167 8.561a.476.476 0 0 0 .47.411h4.878a.476.476 0 1 1 0 .952H5.165a1.43 1.43 0 0 1-1.414-1.235l-1.167-8.56a1.427 1.427 0 0 1 1.413-1.62m11.202 0h-8.41c.081-2.216.74-3.361 1.487-3.97.816-.667 1.848-.787 2.717-.787.873 0 1.904.115 2.719.777.746.606 1.405 1.751 1.486 3.98",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M16.225 13.915c.263 0 .476.213.476.476v1.427h1.427a.476.476 0 0 1 0 .95H16.7v1.428a.476.476 0 0 1-.952 0v-1.427h-1.426a.476.476 0 0 1 0-.951h1.426V14.39c0-.263.213-.476.476-.476"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M16.265 11.167a5.167 5.167 0 1 1 0 10.334 5.167 5.167 0 0 1 0-10.334m0 1.092a4.075 4.075 0 1 0 .001 8.15 4.075 4.075 0 0 0 0-8.15"
  })]
}), 'OrderAndRegister');
//# sourceMappingURL=index.js.map